/*eslint-disable */

import axios from 'axios';
import moment from 'moment';
import root from '../_helpers/roots';

let ivContestListLink = root.ivContestListLink.link;
let pubIvContestInfoLink = root.pubIvContestInfoLink.link;
let pubIvContestSubmitApiList = root.pubIvContestSubmitApiList.link;
let ivQuizFeedbackSubmitionLink = root.ivQuizFeedbackSubmitionLink.link;

export default {
  state: {
  },
  mutations: {
  },
  actions: {
    ivQuizFeedbackSubmittedMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(ivQuizFeedbackSubmitionLink, payload)
          .then(function(response) {
            resolve(response.data);
          })
          .catch(
            function(err) {
              reject(err);
            }
          )
      })
    },
    pubIvContestSubmitAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(pubIvContestSubmitApiList, payload)
          .then(function(response) {
            resolve(response.data);
          })
          .catch(
            function(err) {
              reject(err);
            }
          )
      })
    },
    getIvContestListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(ivContestListLink)
          .then(function(response) {
            resolve(response.data);
          })
          .catch(
            function(err) {
              reject(err);
            }
          )
      })
    },
      getIvContestInfoByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
          axios.get(pubIvContestInfoLink + payload.id +'/')
            .then(function(response) {
              resolve(response.data);
            })
            .catch(
              function(err) {
                reject(err);
              }
            )
        })
      },
  },
  getters: {
  }
}